import React from 'react';
import { drapcodeIcon } from '../custom/icon-library';

const DeleteButton = ({ icon = 'delete', onClick, title, text }) => {
  return (
    <button type="button" className="btn btn-md btn-theme-delete" onClick={onClick} title={title}>
      <i className={`wb ${drapcodeIcon(icon)}`} /> {text}
    </button>
  );
};

export default DeleteButton;
